import { render, staticRenderFns } from "./ComboList.vue?vue&type=template&id=476f71ae&scoped=true"
import script from "./ComboList.vue?vue&type=script&lang=js"
export * from "./ComboList.vue?vue&type=script&lang=js"
import style0 from "./ComboList.vue?vue&type=style&index=0&id=476f71ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476f71ae",
  null
  
)

export default component.exports